var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachingMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.80413 8.91584C4.70696 7.87981 3.41999 7.57593 2.04531 7.51188C1.64758 7.49325 1.53113 7.38526 1.53037 6.992C1.5281 4.92217 1.53037 2.85235 1.52735 0.782525C1.52659 0.511414 1.61506 0.291696 1.91147 0.289461C3.29523 0.276055 4.55195 0.597812 5.50243 1.68076C5.72549 1.93474 5.8306 2.21181 5.82833 2.55964C5.81547 4.57956 5.82228 6.60023 5.82152 8.62015C5.82152 8.69091 5.81321 8.76092 5.80413 8.91584Z",
    fill: "#9E9BA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.47191 8.92689C6.47191 8.71611 6.47191 8.59768 6.47191 8.47926C6.47191 6.5085 6.47871 4.53773 6.46586 2.56771C6.46359 2.22137 6.56416 1.94207 6.78722 1.68735C7.73543 0.60216 8.9914 0.278168 10.3752 0.28934C10.6973 0.292319 10.7683 0.532148 10.7676 0.812941C10.7631 2.3249 10.7653 3.83687 10.7653 5.34883C10.7653 5.91861 10.7646 6.48913 10.7653 7.05891C10.7653 7.32257 10.6436 7.49537 10.3699 7.50505C8.94452 7.55793 7.61142 7.85809 6.47191 8.92689Z",
    fill: "#9E9BA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.848104 1.78847C0.848104 2.26589 0.848104 2.72246 0.848104 3.17903C0.848104 4.44371 0.845079 5.7084 0.849616 6.97234C0.852641 7.74098 1.2723 8.15361 2.0587 8.18266C3.01372 8.21766 3.93017 8.3912 4.7453 8.92076C4.85645 8.99301 4.95929 9.07866 5.0402 9.22837C4.83982 9.19858 4.64019 9.16357 4.43982 9.13974C3.22922 8.99971 2.02921 9.07568 0.83903 9.32594C0.276454 9.44436 0.0980029 9.30359 0.0972468 8.73158C0.0964907 6.62452 0.0964907 4.51671 0.0972468 2.40964C0.0972468 1.84135 0.213694 1.73857 0.848104 1.78847Z",
    fill: "#9E9BA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4455 1.79217C12.0693 1.73184 12.1963 1.84059 12.1963 2.39845C12.1971 4.50626 12.1971 6.61332 12.1963 8.72113C12.1963 9.31326 12.0239 9.43913 11.4288 9.3207C10.1124 9.06002 8.78988 8.95947 7.45754 9.21196C7.38949 9.22462 7.3169 9.21345 7.18457 9.21345C7.69951 8.73901 8.26889 8.49546 8.88213 8.36437C9.33355 8.26754 9.79934 8.2169 10.2613 8.18785C11.0167 8.13944 11.4409 7.73203 11.4432 6.98349C11.4485 5.39631 11.4447 3.80986 11.4447 2.22267C11.4455 2.08935 11.4455 1.95454 11.4455 1.79217Z",
    fill: "#9E9BA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachingMode);
export default __webpack_public_path__ + "static/media/teaching_mode.75d607aae5894226c981eea22bc798db.svg";
export { ForwardRef as ReactComponent };